import { ReactNode } from "react";
import BlankGWIcon from "../../../img/icons/blank-gw.svg?react";
import InternationalDutyIcon from "../../../img/icons/international-duty.svg?react";
import LoanIneligibleIcon from "../../../img/icons/loan-ineligible.svg?react";
import PlayerNotesIcon from "../../../img/icons/player-notes.svg?react";
import SuspensionRiskIcon from "../../../img/icons/suspension-risk.svg?react";
import { notesIcon } from "../playerNotes.css";

const PlayerNotesPropertyIcon = ({
  property,
}: {
  property?: string;
}): ReactNode => {
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

  const iconVariant = prefersDark ? "light" : "default";

  switch (property) {
    case "intl_duty":
      return <InternationalDutyIcon className={notesIcon[iconVariant]} />;
    case "suspension_risk":
      return <SuspensionRiskIcon />;
    case "loan_ineligible":
      return <LoanIneligibleIcon />;
    case "blank_gw":
      return <BlankGWIcon />;
    case "notes_icon":
      return <PlayerNotesIcon className={notesIcon[iconVariant]} />;
    default:
      return null;
  }
};

export default PlayerNotesPropertyIcon;
